export default {
  template_id: 'gh_float',
  html: function (value, func) {
    if (value.class.indexOf('gh_icon') > 0) {
      if(value.icon_id.length == 0) {
        value.icon_id = 'box';
      }
    }
    return `
      <div class="${ value.class }">
      <div class="continer_decorator gh_float">
        ${ value.icon_id || value.name ?
          `<div class="template_icon_title_block_form">
            ${ value.icon_id ? `<span class="template_icon_form" gh-icon="${ value.icon_id } 86BEF6 100% normal"></span>` : `` }
            ${ value.name ? `<span class="template_title_form">${ value.name }</span>` : `` }
            </div>` : ``
        }
        <div class="float_block_template_repeat_form gh_block_title_name">${ func(value.content) }</div>
        </div>
      </div>`;
  }
};
